import React from "react";
import { getTemplate, isClassic } from "./registry";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Story from "@/components/site/Story";
import Approach from "@/components/site/Approach";
import Services from "@/components/site/Services";
import Testimonials from "@/components/site/Testimonials";
import Blog from "@/components/site/Blog";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import ChatbotWidget from "@/components/site/ChatbotWidget";

import MinimalTemplate from "./MinimalTemplate";
import OrganicTemplate from "./OrganicTemplate";
import BoldTemplate from "./BoldTemplate";
import ClinicalTemplate from "./ClinicalTemplate";
import LuxeTemplate from "./LuxeTemplate";

const NEW_TEMPLATES = {
  t2_minimal: MinimalTemplate,
  t3_warm_organic: OrganicTemplate,
  t4_bold_modern: BoldTemplate,
  t5_clinical: ClinicalTemplate,
  t6_luxe: LuxeTemplate,
};

/** Modèle Classic (design existant) — honore les bascules de sections. */
const ClassicTemplate = ({ tenant, toggles = {} }) => {
  const show = (k) => toggles?.[k] !== false;
  return (
    <main data-testid={`tenant-landing-${tenant.slug}`} className="bg-eh-bg text-eh-ink">
      {/* The header lists the same sitemap the footer does, so it needs the same toggles:
          an anchor to a section this practice switched off leads nowhere. */}
      <Navbar toggles={toggles} />
      <Hero />
      <Marquee />
      {show("story") && <Story />}
      {show("approach") && <Approach />}
      {show("services") && <Services />}
      {show("testimonials") && <Testimonials />}
      {show("blog") && <Blog />}
      {show("contact") && <Contact />}
      {/* The footer lists the sections that EXIST on this site, so it needs the same
          toggles the sections above are gated on. */}
      <Footer toggles={toggles} />
      <ChatbotWidget />
    </main>
  );
};

/**
 * SiteTemplateRenderer — choisit le modèle de site du tenant.
 * t1_classic = design existant (Émilie). t2..t6 = nouveaux modèles distincts.
 */
export default function SiteTemplateRenderer({ tenant }) {
  const templateId = tenant?.site_template || "t1_classic";
  const toggles = tenant?.section_toggles || {};

  if (isClassic(templateId)) {
    return <ClassicTemplate tenant={tenant} toggles={toggles} />;
  }
  const Template = NEW_TEMPLATES[templateId] || MinimalTemplate;
  const tpl = getTemplate(templateId);
  return (
    <>
      <Template template={tpl} toggles={toggles} />
      <ChatbotWidget />
    </>
  );
}
